import { render, staticRenderFns } from "./GUNeedCompletionStatistics.vue?vue&type=template&id=7fcfe006&"
import script from "./GUNeedCompletionStatistics.vue?vue&type=script&lang=js&"
export * from "./GUNeedCompletionStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports